var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[_c('tabbar'),_c('router-view'),_c('banner'),(_vm.moduleFlag)?_c('loginModule'):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }